import Core from '../plugin-core-system/core.class.js';
import Focus from '../helper/focus.helper.js';

export default class CsFormFields extends Core {

    static options = {};

    /**
     * init select form fields with plugin library select2
     */
    initSelect() {
        const selectElements = this.el.querySelectorAll('.js-select');

        if (selectElements.length) {
            selectElements.forEach((element) => {
                // eslint-disable-next-line
                jQuery(element).selectWoo({
                    placeholder: element.dataset.placeholder,
                    minimumResultsForSearch: -1
                });
            });
        }
    }

    /**
     * init custom file upload
     */
    initFileUpload() {
        const fileUploadElements = this.el.querySelectorAll('.js-file-upload');

        if (fileUploadElements.length) {
            fileUploadElements.forEach((element) => {

                const inputFile = element.querySelector('.js-file-upload-input');

                // trigger upload on space & enter = default button functionality
                element.addEventListener('keydown', function (e) {
                    if (e.which === 32 || e.which === 13) {
                        e.preventDefault();
                        inputFile.click();
                    }
                });

                // change file name for text input
                inputFile.addEventListener('change', (e) => {
                    const filename = e.target.value.split('\\').pop();
                    const filenameInput = element.querySelector('.js-file-upload-filename');
                    filenameInput.value = filename;
                    filenameInput.placeholder = filename;
                    Focus.setFocusToElement(filenameInput);
                });
            });
        }
    }

    init() {
        this.initSelect();
        this.initFileUpload();
    }
}
